import { render, staticRenderFns } from "./CRDMatchingList.vue?vue&type=template&id=bf1f8c3e&scoped=true&"
import script from "./CRDMatchingList.vue?vue&type=script&lang=js&"
export * from "./CRDMatchingList.vue?vue&type=script&lang=js&"
import style0 from "./CRDMatchingList.vue?vue&type=style&index=0&id=bf1f8c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1f8c3e",
  null
  
)

export default component.exports